<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>
    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <atoms-input-text
            class="u-mb30"
            label="記入者："
            type="text"
            placeholder="記入者"
            inputmode="text"
            :required="false"
            v-model="formData.writer"
            setKey="writer"
            @input-emit="handleUpdateValue"
          ></atoms-input-text>

        <section class="form-section u-mb20">

          <atoms-label label="１自立生活能力" class="u-mb15" />

          <p class="u-mt20" style="font-size: 14px">
            ※記入にあたって以下を基準にし、当てはまる番号を選択<br />
            <span class="bold">
              <span class="u-mr10">1:自立</span>
              <span class="u-mr10">2:見守り</span>
              <span class="u-mr10">3:一部介助</span>
              <span>4:全介助</span>
            </span>
          </p>
          <div class="u-mb40">
            <p class="u-mt20 u-mb0 bold">A身の回りのこと</p>
            <atoms-input-radio-block
              label="（1）個人衛生"
              v-model="formData.livingAbilityPersonalBelongingsPersonalHygiene"
              setKey="livingAbilityPersonalBelongingsPersonalHygiene"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）自室の整頓"
              v-model="formData.livingAbilityPersonalBelongingsRoomArrangement"
              setKey="livingAbilityPersonalBelongingsRoomArrangement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）金銭管理"
              v-model="formData.livingAbilityPersonalBelongingsMoneyManagement"
              setKey="livingAbilityPersonalBelongingsMoneyManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（4）洗濯"
              v-model="formData.livingAbilityPersonalBelongingsWashing"
              setKey="livingAbilityPersonalBelongingsWashing"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（5）買い物"
              v-model="formData.livingAbilityPersonalBelongingsShopping"
              setKey="livingAbilityPersonalBelongingsShopping"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（6）食事をとる"
              v-model="formData.livingAbilityPersonalBelongingsMeals"
              setKey="livingAbilityPersonalBelongingsMeals"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（7）食事をつくる"
              v-model="formData.livingAbilityPersonalBelongingsMakeMeal"
              setKey="livingAbilityPersonalBelongingsMakeMeal"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilityPersonalBelongingsSpecificSituation
              "
              setKey="livingAbilityPersonalBelongingsSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="u-mb20">
            <p class="u-mt20 u-mb0 bold">B安全管理</p>
            <atoms-input-radio-block
              label="（1）危険な行為かどうかの判断ができる"
              v-model="formData.livingAbilitySafetyManagementCrisisManagement"
              setKey="livingAbilitySafetyManagementCrisisManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）火の始末ができる"
              v-model="formData.livingAbilitySafetyManagementDisposeOfFire"
              setKey="livingAbilitySafetyManagementDisposeOfFire"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilitySafetyManagementSpecificSituation"
              setKey="livingAbilitySafetyManagementSpecificSituation"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>
      <div class="tab -1" v-if="tabs === 1">
        <section class="form-section u-mb20">

          <atoms-label label="１自立生活能力" class="u-mb15" />

          <p class="u-mt20" style="font-size: 14px">
            ※記入にあたって以下を基準にし、当てはまる番号を選択<br />
            <span class="bold">
              <span class="u-mr10">1:自立</span>
              <span class="u-mr10">2:見守り</span>
              <span class="u-mr10">3:一部介助</span>
              <span>4:全介助</span>
            </span>
          </p>
          <div class="u-mb40">
            <p class="u-mt20 u-mb0 bold">C健康管理</p>

            <atoms-input-radio-block
              label="（1）定期的な通院ができる"
              v-model="formData.livingAbilityHealthManagementRegularVisits"
              setKey="livingAbilityHealthManagementRegularVisits"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）服薬管理ができる"
              v-model="
                formData.livingAbilityHealthManagementMedicationManagement
              "
              setKey="livingAbilityHealthManagementMedicationManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）身体健康の管理"
              v-model="
                formData.livingAbilityHealthManagementPhysicalHealthManagement
              "
              setKey="livingAbilityHealthManagementPhysicalHealthManagement"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilityHealthManagementSpecificSituation"
              setKey="livingAbilityHealthManagementSpecificSituation"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-textarea>
          </div>

          <div class="u-mb40">
            <p class="u-mt20 u-mb0 bold">D社会資源の活用</p>

            <atoms-input-radio-block
              label="（1）交通機関の利用ができる"
              v-model="formData.livingAbilitySocialResourcesUseOfTransportation"
              setKey="livingAbilitySocialResourcesUseOfTransportation"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）金融機関の利用ができる"
              v-model="
                formData.livingAbilitySocialResourcesUseOfFinancialInstitutions
              "
              setKey="livingAbilitySocialResourcesUseOfFinancialInstitutions"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）電話の利用ができる"
              v-model="formData.livingAbilitySocialResourcesUseOfTelephone"
              setKey="livingAbilitySocialResourcesUseOfTelephone"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="formData.livingAbilitySocialResourcesSpecificSituation"
              setKey="livingAbilitySocialResourcesSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="u-mb40">
            <p class="u-mt20 u-mb0 bold">E対人関係</p>

            <atoms-input-radio-block
              label="（1）あいさつなど最低限のつきあいができる"
              v-model="
                formData.livingAbilityInterpersonalRelationsMinimalRelationship
              "
              setKey="livingAbilityInterpersonalRelationsMinimalRelationship"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）協調性"
              v-model="formData.livingAbilityInterpersonalRelationsCooperation"
              setKey="livingAbilityInterpersonalRelationsCooperation"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）自発性"
              v-model="formData.livingAbilityInterpersonalRelationsSpontaneous"
              setKey="livingAbilityInterpersonalRelationsSpontaneous"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（4）友人等との付き合い"
              v-model="
                formData.livingAbilityInterpersonalRelationsHangingOutWithFriends
              "
              setKey="livingAbilityInterpersonalRelationsHangingOutWithFriends"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilityInterpersonalRelationsSpecificSituation
              "
              setKey="livingAbilityInterpersonalRelationsSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
          <div class="u-mb20">
            <p class="u-mt20 u-mb0 bold">F社会的役割・時間の活用</p>

            <atoms-input-radio-block
              label="（1）自分なりの社会的役割を持つ"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（2）自由時間のすごし方"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeFreeTime
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeFreeTime"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-radio-block
              label="（3）生活リズム"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeLifeRhythm
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeLifeRhythm"
              :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio-block>

            <atoms-input-textarea
              label="具体的な様子"
              placeholder="具体的な様子"
              :required="false"
              v-model="
                formData.livingAbilitySocialRoleUtilizationOfTimeSpecificSituation
              "
              setKey="livingAbilitySocialRoleUtilizationOfTimeSpecificSituation"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -2" v-if="tabs === 2">
        <section class="form-section u-mb20">

          <atoms-label label="２緊急時の対応" class="u-mb15" />

          <p class="u-mt20" style="font-size: 14px">
            ※記入にあたって以下を基準にし、当てはまる番号を選択<br />
            <span class="bold">
              <span class="u-mr10">1:自立</span>
              <span class="u-mr10">2:見守り</span>
              <span class="u-mr10">3:一部介助</span>
              <span>4:全介助</span>
            </span>
          </p>

          <atoms-input-radio-block
            label="A心配事（ストレスをうけた）の相談ができる"
            v-model="formData.emergencyResponseConsultationOfConcerns"
            setKey="emergencyResponseConsultationOfConcerns"
            :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="B悪化時の対処"
            v-model="formData.emergencyResponseDeal"
            setKey="emergencyResponseDeal"
            :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.emergencyResponseSpecificSituation"
            setKey="emergencyResponseSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>
        <section class="form-section u-mb20">

          <atoms-label label="３配慮が必要な社会行動" class="u-mb15" />

          <p class="u-mt20" style="font-size: 14px">
            ※記入にあたって以下を基準にし、当てはまる番号を選択<br />
            <span class="bold">
              <span class="u-mr10">1:自立</span>
              <span class="u-mr10">2:見守り</span>
              <span class="u-mr10">3:一部介助</span>
              <span>4:全介助</span>
            </span>
          </p>

          <atoms-input-radio-block
            label="A公共の場でのマナーに配慮できる"
            v-model="formData.behaviorsThatRequireConsiderationMannersInPublic"
            setKey="behaviorsThatRequireConsiderationMannersInPublic"
            :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="B自殺ないし自傷の念慮や行為がない"
            v-model="
              formData.behaviorsThatRequireConsiderationActsSuchAsSelfHarm
            "
            setKey="behaviorsThatRequireConsiderationActsSuchAsSelfHarm"
            :options="useDefine.defineObject.NUMBERSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="
              formData.behaviorsThatRequireConsiderationSpecificSituation
            "
            setKey="behaviorsThatRequireConsiderationSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            label="＊要配慮行動"
            placeholder="要配慮行動"
            :required="false"
            v-model="
              formData.behaviorsThatRequireConsiderationRequiringSpecialAction
            "
            setKey="behaviorsThatRequireConsiderationRequiringSpecialAction"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>
      </div>

      <div class="tab -3" v-if="tabs === 3">
        <section class="form-section u-mb20">

          <atoms-label label="４生活上の困難な問題" class="u-mb15" />

          <p class="u-mt20" style="font-size: 14px">
            ※記入にあたって以下を基準にし、当てはまる番号を選択<br />
            <span class="bold">
              <span class="u-mr10">A:すぐに要改善</span>
              <span class="u-mr10">B：改善が必要</span>
              <span class="u-mr10">C：できるなら改善が必要</span>
              <span>D：現状維持</span>
            </span>
          </p>
          <atoms-input-radio-block
            label="（1）生活費など経済的な問題"
            v-model="formData.lifeProblemsFinancialProblems"
            setKey="lifeProblemsFinancialProblems"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="（2）住まいの問題"
            v-model="formData.lifeProblemsHousingProblems"
            setKey="lifeProblemsHousingProblems"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="（3）日中活動の場の問題"
            v-model="formData.lifeProblemsProblemsWithDaytimeActivities"
            setKey="lifeProblemsProblemsWithDaytimeActivities"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="（4）気軽に相談できる相談相手の問題"
            v-model="formData.lifeProblemsProblemsWithCounselor"
            setKey="lifeProblemsProblemsWithCounselor"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="（5）日常生活について手助けをしてくれる人の問題"
            v-model="formData.lifeProblemsHelpProblem"
            setKey="lifeProblemsHelpProblem"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="（6）家族関係の問題"
            v-model="formData.lifeProblemsFamilyRelationshipIssues"
            setKey="lifeProblemsFamilyRelationshipIssues"
            :options="useDefine.defineObject.ALPHABETSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-textarea
            label="備考"
            placeholder="備考"
            :required="false"
            v-model="formData.lifeProblemsRemarks"
            setKey="lifeProblemsRemarks"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            label="＊その他の問題"
            placeholder="その他の問題"
            :required="false"
            v-model="formData.lifeProblemsOtherIssues"
            setKey="lifeProblemsOtherIssues"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>

        <section class="form-section u-mb20">

          <atoms-label label="５主治医の意見" class="u-mb15" />

          <atoms-input-textarea
            label="a.福祉サービスの利用について"
            placeholder="福祉サービスの利用について"
            :required="false"
            v-model="formData.doctorOpinionUseOfWelfareServices"
            setKey="doctorOpinionUseOfWelfareServices"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            label="b.禁忌事項等"
            placeholder="禁忌事項等"
            :required="false"
            v-model="formData.doctorOpinionContraindications"
            setKey="doctorOpinionContraindications"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <div class="form-content u-mt30 u-mb20">
            <p class="form-content-title">情報聴取先</p>

            <atoms-input-text
              label="機関名："
              type="text"
              placeholder="機関名"
              inputmode="text"
              :required="false"
              v-model="
                formData.doctorOpinionInformationListeningDestinationInstitutionAttended
              "
              setKey="doctorOpinionInformationListeningDestinationInstitutionAttended"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-text
              label="医師名："
              type="text"
              placeholder="医師名"
              inputmode="text"
              :required="false"
              v-model="
                formData.doctorOpinionInformationListeningDestinationDoctor
              "
              setKey="doctorOpinionInformationListeningDestinationDoctor"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>

            <atoms-input-date-picker
              :date="
                formData.doctorOpinionInformationListeningDestinationEnteredDate
              "
              label="記入日："
              set-key="doctorOpinionInformationListeningDestinationEnteredDate"
              @input-value="handleInputValue"
            />
          </div>
        </section>

        <!-- <atoms-input-date
          label="記入日："
          type="date"
          inputmode=""
          placeholder=""
          :required="false"
          v-model="
            formData.doctorOpinionInformationListeningDestinationEnteredDate
          "
          setKey="doctorOpinionInformationListeningDestinationEnteredDate"
          @input-emit="handleUpdateValue"
        ></atoms-input-date> -->
      </div>

      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'

export default {
  data() {
    return {
      tabsMin: 0,
      tabsMax: 3,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        livingAbilityPersonalBelongingsPersonalHygiene: '',
        livingAbilityPersonalBelongingsRoomArrangement: '',
        livingAbilityPersonalBelongingsMoneyManagement: '',
        livingAbilityPersonalBelongingsWashing: '',
        livingAbilityPersonalBelongingsShopping: '',
        livingAbilityPersonalBelongingsMeals: '',
        livingAbilityPersonalBelongingsMakeMeal: '',
        livingAbilityPersonalBelongingsSpecificSituation: '',
        livingAbilitySafetyManagementCrisisManagement: '',
        livingAbilitySafetyManagementDisposeOfFire: '',
        livingAbilitySafetyManagementSpecificSituation: '',
        livingAbilityHealthManagementRegularVisits: '',
        livingAbilityHealthManagementMedicationManagement: '',
        livingAbilityHealthManagementPhysicalHealthManagement: '',
        livingAbilityHealthManagementSpecificSituation: '',
        livingAbilitySocialResourcesUseOfTransportation: '',
        livingAbilitySocialResourcesUseOfFinancialInstitutions: '',
        livingAbilitySocialResourcesUseOfTelephone: '',
        livingAbilitySocialResourcesSpecificSituation: '',
        livingAbilityInterpersonalRelationsMinimalRelationship: '',
        livingAbilityInterpersonalRelationsCooperation: '',
        livingAbilityInterpersonalRelationsSpontaneous: '',
        livingAbilityInterpersonalRelationsHangingOutWithFriends: '',
        livingAbilityInterpersonalRelationsSpecificSituation: '',
        livingAbilitySocialRoleUtilizationOfTimeOwnSocialRole: '',
        livingAbilitySocialRoleUtilizationOfTimeFreeTime: '',
        livingAbilitySocialRoleUtilizationOfTimeLifeRhythm: '',
        livingAbilitySocialRoleUtilizationOfTimeSpecificSituation: '',
        emergencyResponseConsultationOfConcerns: '',
        emergencyResponseDeal: '',
        emergencyResponseSpecificSituation: '',
        behaviorsThatRequireConsiderationMannersInPublic: '',
        behaviorsThatRequireConsiderationActsSuchAsSelfHarm: '',
        behaviorsThatRequireConsiderationSpecificSituation: '',
        behaviorsThatRequireConsiderationRequiringSpecialAction: '',
        lifeProblemsFinancialProblems: '',
        lifeProblemsHousingProblems: '',
        lifeProblemsProblemsWithDaytimeActivities: '',
        lifeProblemsProblemsWithCounselor: '',
        lifeProblemsHelpProblem: '',
        lifeProblemsFamilyRelationshipIssues: '',
        lifeProblemsRemarks: '',
        lifeProblemsOtherIssues: '',
        doctorOpinionUseOfWelfareServices: '',
        doctorOpinionContraindications: '',
        doctorOpinionInformationListeningDestinationInstitutionAttended: '',
        doctorOpinionInformationListeningDestinationDoctor: '',
        doctorOpinionInformationListeningDestinationEnteredDate: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
    handleInputValue(value, key) {
      const date = `${value.getFullYear()}-${
        value.getMonth() + 1
      }-${value.getDate()}`
      this.formData[key] = date
      this.$emit('input-emit', this.setObjectKey, key, date)
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
